module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB2002-b2401adb14ab5953d73d869e09e6ca3e.png";